import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { LocalizeConfig } from './localize-config';
import { LocalizeService } from './localize.service';

export function initLocalization(localizeService: LocalizeService) {
  return () => localizeService.initLocalization();
}

export function initLOCALE_ID(localizeService: LocalizeService) {
  return localizeService.getCurrentLocale();
}

export function HttpLoaderFactory(http: HttpClient, config: LocalizeConfig) {
  return new TranslateHttpLoader(http, config.jsonPath, '.json');
}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [TranslateModule],
})
export class LocalizeModule {
  static forRoot(config: LocalizeConfig): ModuleWithProviders<LocalizeModule> {
    return {
      ngModule: LocalizeModule,
      providers: [
        {
          provide: LocalizeConfig,
          useValue: config,
        },
        LocalizeService,
        ...(TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient, LocalizeConfig],
          },
        }).providers || []),
        {
          provide: LOCALE_ID,
          useFactory: initLOCALE_ID,
          deps: [LocalizeService],
        },
        {
          provide: APP_INITIALIZER,
          useFactory: initLocalization,
          deps: [LocalizeService],
          multi: true,
        },
      ],
    };
  }
}
